import { render, staticRenderFns } from "./HeaderGlobalSearch.vue?vue&type=template&id=2f3ee99c&"
import script from "./HeaderGlobalSearch.vue?vue&type=script&lang=js&"
export * from "./HeaderGlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGlobalSearch.vue?vue&type=style&index=0&id=2f3ee99c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports